import React, { useState, useEffect } from "react";
import { Offcanvas, Navbar } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import { useFilter } from "./VerifyEmail";
import axios from "axios";
import PriceRangeModal from "./PriceRangeModal";

const MobileHeader = () => {
  const [show, setShow] = useState(false);
  const [priceModalOpen, setPriceModalOpen] = useState(false);
  const { searchText, handleKeyDown, setSearchText, handleSearchClick, handleInputChange, priceRangeName, setPriceRangeName } = useFilter();
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const togglePriceModal = () => setPriceModalOpen(!priceModalOpen);

  const handlePriceSelect = (price) => {
    setPriceRangeName(price.label);
    navigate(`/product-list?maxPrice=${price.endPrice}&minPrice=${price.startPrice}&rangeName=${encodeURIComponent(price.label)}`);
    handleClose();
  };

  const [priceRanges, setPriceRanges] = useState([]);
  const [CategoryData, setCategoryData] = useState([]);
  const [displayLimit, setDisplayLimit] = useState(10);

  const fetchPriceRanges = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/PriceRangeMaster`);
      setPriceRanges(res.data || []);
    } catch (error) {
      console.error("Error fetching price ranges:", error);
    }
  };

  const fetchData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/auth/list/CategoryMaster`
    )
    setCategoryData(res.data)
  };

  useEffect(() => {
    setSearchText("")
    fetchData();
    fetchPriceRanges();
  }, []);

  const handleViewMore = () => {
    setDisplayLimit(CategoryData.length);
  };

  return (
    <div>
      <Navbar className="mobile-menu-toggle " expand={false}>
        <Navbar.Toggle aria-controls="offcanvas-navbar" onClick={handleShow}>
          <FaBars style={{ fontSize: "24px", color: "#000" }} />
        </Navbar.Toggle>
      </Navbar>

      <Offcanvas className="mobileHaderBody" show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="row g-2 mb-2 align-items-center">
            <div className="col-5">
              <button
                type="button"
                className="btn btn-outline-dark w-100 text-start d-flex justify-content-between align-items-center form-control br-0"
                onClick={togglePriceModal}
                style={{ padding: '8px 10px', fontSize: '12px', height: '40px', whiteSpace: 'nowrap', overflow: 'hidden' }}
              >
                <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{priceRangeName || "Select Price"}</span>
                <i className="w-icon-angle-down" style={{ marginLeft: '4px' }}></i>
              </button>
            </div>
            <div className="col-7">
              <form action="#" className="input-wrapper" style={{ height: '40px' }}>
                <div className="mobileSearchDiv d-flex" style={{ height: '100%' }}>
                  <input
                    type="text"
                    className="form-control"
                    name="search"
                    id="search"
                    style={{ height: '100%', borderRadius: '0', fontSize: '13px' }}
                    value={searchText}
                    onChange={(e) => {
                      handleInputChange(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      handleKeyDown(e);
                      if (e.key === 'Enter') {
                        handleClose();
                      }
                    }}
                    autoComplete="off"
                    placeholder="Search"
                  />
                  <button
                    className="btn btn-search searchBtn"
                    type="button"
                    style={{ height: '100%', padding: '0 15px', color: '#fff', background: '#000' }}
                    onClick={() => {
                      handleSearchClick();
                      handleClose();
                    }}>
                    <i className="w-icon-search" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        
          <div className="tab">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <Link to="/category" className="nav-link">Categories</Link>
              </li>
            </ul>
          </div>

          <div className="tab-pane active" id="categories">
            <ul className="mobile-menu">
              {CategoryData && CategoryData.length > 0 && CategoryData.slice(0, displayLimit).map((category, index) => (
                <li key={index}>
                  <Link to={`/product-list?category=${category._id}&categoryName=${encodeURIComponent(category.categoryName)}`} onClick={handleClose}>
                    {category.categoryName}
                  </Link>
                </li>
              ))}


              <li>
                <a href="/category" className="font-weight-bold text-uppercase ls-25">
                  View All Categories<i className="w-icon-angle-right" />
                </a>
              </li>

            </ul>
          </div>

        </Offcanvas.Body>
      </Offcanvas>
      <PriceRangeModal
        show={priceModalOpen}
        onHide={togglePriceModal}
        priceRanges={priceRanges}
        onSelectPrice={handlePriceSelect}
      />
    </div>
  );
};

export default MobileHeader;
